import React from 'react'
import { useLocation, useNavigationType } from 'react-router-dom'
import { clientLogger } from '../../utils/observability'

export const RouteChangeTracker = () => {
  const location = useLocation()
  const navigationType = useNavigationType()

  React.useEffect(() => {
    clientLogger.action('route_change', {
      navigationType,
      pathname: location.pathname,
      search: location.search || undefined,
      hash: location.hash || undefined,
    })
  }, [location.hash, location.pathname, location.search, navigationType])

  return null
}
